export default __webpack_public_path__ + "images/google-textbook.7d56f90d.png";